// D-142 — sondage discret : n'interroge le serveur que si l'onglet est visible.
// Un premier appel immédiat, puis un appel à chaque période ; au retour de
// visibilité, rattrape si la dernière lecture est plus vieille qu'une période.
export const PERIODE_SONDAGE_TICKETS_MS = 5 * 60 * 1000;

export function demarrerSondageVisible(fn, periodeMs, doc = document, maintenant = Date.now) {
  let derniere = -Infinity;
  const lire = () => {
    derniere = maintenant();
    fn();
  };
  const visible = () => !doc.hidden;

  if (visible()) lire();
  const minuteur = setInterval(() => {
    if (visible()) lire();
  }, periodeMs);
  const auRetour = () => {
    if (visible() && maintenant() - derniere >= periodeMs) lire();
  };
  doc.addEventListener("visibilitychange", auRetour);

  return () => {
    clearInterval(minuteur);
    doc.removeEventListener("visibilitychange", auRetour);
  };
}
